import { UpdateUserPayload } from "@coworker/apprestructured/src/shared/hooks/users/useUpdateUsers";
import { User } from "@coworker/apprestructured/src/shared/types/user";
import { TEAM_DELETION_FLOW_OPERATIONS } from "../../hooks/TeamDeletionOperations";
import { OperationStepProps } from "../types";
import { MoveUsersToTeamSheet } from "./components/MoveUsersToTeamSheet/MoveUsersToTeamSheet";
import { Team } from "./components/MoveUsersToTeamSheet/types";

type MoveUsersToTeamStepProps = OperationStepProps & {
  visible: boolean;
  teams: Team[];
  users: User[];
};

export const MoveUsersToTeamStep = ({
  visible,
  teams,
  users,
  goToPreviousStep,
  goToNextStep,
  teamDeletionFlowOperations,
}: MoveUsersToTeamStepProps) => {
  const handleMoveUsersToTeam = (team: Team) => {
    teamDeletionFlowOperations.register({
      type: TEAM_DELETION_FLOW_OPERATIONS.MOVE_USERS_TO_TEAM,
      payload: {
        users: users.map<UpdateUserPayload>((user) => ({
          uid: user.uid,
          countryId: user.countryId,
          teamId: team.id,
          storeId: team.storeId,
        })),
      },
    });
    goToNextStep();
  };

  return (
    <MoveUsersToTeamSheet
      visible={visible}
      teams={teams}
      onClose={goToPreviousStep}
      onConfirm={handleMoveUsersToTeam}
    />
  );
};
